import { SvgIconType } from './svg.interface';

const LogOut: SvgIconType = ({ width = 12, height = 12, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.5 3L11.25 5.99996L7.5 9V7.5L3.75 7.49996V4.5L7.5 4.50004V3Z"
      fill="#3AA5DC"
    />
    <path
      d="M2.25 1.49998L7.5 1.49998V-7.28522e-09L2.08333 2.004e-05C1.35 2.004e-05 0.75 0.60002 0.75 1.33335L0.75 10.6667C0.75 11.4 1.35 12 2.08333 12L7.5 12L7.5 10.5L2.25 10.5L2.25 1.49998Z"
      fill="#3AA5DC"
    />
  </svg>
);

export default LogOut;
